import { render, staticRenderFns } from "./agreementIOS.vue?vue&type=template&id=35810ec6&scoped=true&"
import script from "./agreementIOS.vue?vue&type=script&lang=js&"
export * from "./agreementIOS.vue?vue&type=script&lang=js&"
import style0 from "./agreementIOS.vue?vue&type=style&index=0&id=35810ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35810ec6",
  null
  
)

export default component.exports